var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "#122A96",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.76 8.571-2.87 6.837H11L9.61 10a.74.74 0 0 0-.42-.605 7.7 7.7 0 0 0-1.74-.586v-.198h3c.199.002.39.074.54.203.15.13.25.307.28.501l.74 3.97 1.84-4.654zm7.33 4.604c0-1.796-2.5-1.895-2.48-2.709 0-.238.24-.506.75-.565.6-.06 1.205.042 1.75.297l.31-1.448a5 5 0 0 0-1.66-.298c-1.75 0-3 .923-3 2.262 0 .993.88 1.528 1.55 1.856.67.327.92.556.92.853 0 .457-.55.655-1.06.665a3.7 3.7 0 0 1-1.82-.426L18 15.16a5.5 5.5 0 0 0 2 .357c1.86 0 3.07-.913 3.08-2.342m4.62 2.233h1.63L27.91 8.57h-1.5a.83.83 0 0 0-.76.506L23 15.407h1.86l.36-.991h2.27zm-2-2.421.94-2.56.56 2.55zM18.26 8.57l-1.46 6.837h-1.74l1.46-6.837z"
  })));
};
export default SvgVisa;